import React from "react";

const Error404 = () => {
  return <div>ooops! something went wrong</div>;
};

export default Error404;
